export const wearSchedule = [
  { label: "14 days", value: "1" },
  { label: "10 days", value: "2" },
  { label: "7 days", value: "7" },
];
